var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.5,
    viewBox: "0 0 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10189",
    "data-name": "Group 10189",
    transform: "translate(20123.75 2015.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M10,0A10,10,0,1,0,20,10,10.029,10.029,0,0,0,10,0Z",
    transform: "translate(-20123 -2015)",
    fill: "none",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7410",
    "data-name": "Path 7410",
    d: "M-20113.6-2007.393l5.041-5.393",
    transform: "translate(2.35 0.553)",
    fill: "none",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7411",
    "data-name": "Path 7411",
    d: "M-20113.6-2005.658l5.158,5.393",
    transform: "translate(2.35 2.336)",
    fill: "none",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7412",
    "data-name": "Path 7412",
    d: "M-20115.383-2005.658l-5.158,5.393",
    transform: "translate(0.615 2.336)",
    fill: "none",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7413",
    "data-name": "Path 7413",
    d: "M-20115.453-2007.44l-4.807-5.158",
    transform: "translate(0.685 0.6)",
    fill: "none",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7414",
    "data-name": "Path 7414",
    d: "M8.5,11A2.5,2.5,0,1,1,11,8.5,2.507,2.507,0,0,1,8.5,11Z",
    transform: "translate(-20121.5 -2013.5)",
    fill: "#606060",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.17a30a9605015e23643c3e1b0c85d235.svg";
export { ForwardRef as ReactComponent };